import * as React from "react";
import { StyleSheet } from "react-native";
import Colors from "../../constants/Colors";
import { View, Text, Button } from "../../components/Themed";
import PageHeader from "../../components/PageHeader";
import Icon from "../../components/Icon";

export default function OpenHouseError({ navigation }: any) {
  const BackButton = () => (
    <Icon
      name="arrow-left"
      color={Colors.primary_500}
      size={24}
      onPress={() => navigation.goBack()}
    />
  );

  const PageTitleContainer = (props: any) => (
    <View style={styles.pageTitleContainer}>{props.children}</View>
  );

  const PageTitle = () => (
    <Text
      size={18}
      lineHeight={24}
      weight="SemiBold"
      lightColor={Colors.nuetral_grey_700}
    >
      Unable to Load Form
    </Text>
  );

  return (
    <View
      lightColor={Colors.background}
      darkColor={Colors.nuetral_grey_600}
      style={styles.container}
    >
      <PageHeader
        leftComponent={<BackButton />}
        centerComponent={
          <PageTitleContainer>
            <PageTitle />
          </PageTitleContainer>
        }
      />
      <View style={styles.content}>
        <Icon name="alert-circle" size={64} color={Colors.go_danger_500} />
        <Text
          size={20}
          lineHeight={28}
          weight="SemiBold"
          lightColor={Colors.nuetral_grey_700}
          style={styles.title}
        >
          Error Loading Check-in Form
        </Text>
        <Text
          size={16}
          lineHeight={24}
          lightColor={Colors.nuetral_grey_600}
          style={styles.message}
        >
          There was an error loading the check-in form. Please try again later
          or contact support if the problem persists.
        </Text>
        <Button
          style={styles.button}
          text="Try Again"
          textColor={Colors.base_colors_white}
          lightColor={Colors.primary_500}
          darkColor={Colors.primary_500}
          onPress={() => navigation.replace("QrCheckIn")}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 24,
  },
  pageTitleContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    textAlign: "center",
    marginTop: 24,
    marginBottom: 8,
  },
  message: {
    textAlign: "center",
    marginBottom: 32,
  },
  button: {
    width: 186,
  },
});
